module.exports = __webpack_public_path__ + "static/media/03A.dc30a004.png";